import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/styles.css";
import "../styles/propagabasico.css"
import {
  Container,
  Nav,
  Navbar,
  Image,
  Button,
  Col,
  Card,
} from "react-bootstrap";
import LogoTransparente from "../assets/logo-transparente.png"
const Noticias = () => {
    return (
    <>
        <Navbar
          sticky="top"
          className="navbar-expand-xxxl"
          collapseOnSelect  
          expand="xxxl"
        >
          <Container>
            <Navbar.Brand href="/Home" className="text-white">
              <Image
                style={{
                  width: "70px",
                  marginRight: "10px",
                }}
                src={LogoTransparente}
              />
              SETEPEB
            </Navbar.Brand>
            <Navbar.Toggle className="bg-white"/>
            <Navbar.Collapse className="fw-bolder text-black">
              <Nav className="ml-auto bg-white" id="warpcollapse">
                <Nav.Link href="/Home" className="text-black">Home</Nav.Link>
                <Nav.Link href="/Home#cursos" className="text-black">Cursos</Nav.Link>
                <Nav.Link href="/noticias" className="text-black">Notícias</Nav.Link>
                <Nav.Link href="/Home#setepeb" className="text-black">Sede</Nav.Link>
                <Nav.Link href="/Home#sobre" className="text-black">Sobre</Nav.Link>
                <Nav.Link href="/Home#contato" className="text-black">Contato</Nav.Link>
                <Nav.Link
                  className="text-primary fw-bolder"
                  href="http://52.205.173.108:8080/sais/"
                  target="_blank"
                >
                  Acesso
                </Nav.Link>
              </Nav>
            </Navbar.Collapse> 
          </Container>
        </Navbar>
        <Container>
            <Col sm={12} md={4} className="p-4 d-flex justify-content-center">
          <Card style={{ width: "100%" }}>
            <Card.Img
              className="d-flex justify-content-center"
              style={{ width: "80%", margin: "0 auto" }}
              variant="top"
              src={LogoTransparente}
            />
            <Card.Body>
              <Card.Title>Edital SETEPEB - 2026</Card.Title>
<Card.Text className="text-justify">
  <strong>ABERTURA DE PRAZO PARA CANDIDATURA</strong>
  <br />
  <br />

  O Seminário Teológico Pentecostal do Brasil (<strong>SETEPEB</strong>) torna
  público o edital de abertura de prazo para apresentação de candidatura ao
  cargo de <strong>Diretor(a) Administrativo(a) Executivo(a)</strong>, bem como
  a convocação de nova eleição.
  <br />
  <br />

  A eleição está marcada para o dia{" "}
  <strong>10 de fevereiro de 2026</strong>.
  <br />
  <br />

  O período de inscrições ocorrerá entre{" "}
  <strong>01/01/2026</strong> e{" "}
  <strong>01/02/2026</strong>.
  <br />
  <br />

  Para mais informações e critérios de participação, consulte o edital completo
  disponível abaixo.
</Card.Text>
             <div className="d-flex justify-content-center mt-4">
  <Button
    as="a"
    href="/docs/Edital Setepeb 2026.pdf"
    download
    size="lg"
    variant="primary"
  >
     Baixar Edital SETEPEB 2026
  </Button>
</div>

            </Card.Body>
          </Card>
        </Col>
        </Container>
        
    </>
    );
};
 
export default Noticias;